module.exports = __webpack_public_path__ + "static/icon-upcoming-480px-153c0538f211b3f115bb5f68b6975f16.png";